import { useEffect, useState } from 'react';
import { Maximize } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';

const isFullscreen = () => Boolean(document.fullscreenElement);

// Simulations and quizzes only run in full screen; leaving full screen hides the page until the learner goes back
export const FullscreenGate = ({ attemptLabel }) => {
    const [full, setFull] = useState(isFullscreen);
    useEffect(() => {
        const sync = () => setFull(isFullscreen());
        document.addEventListener('fullscreenchange', sync);
        return () => document.removeEventListener('fullscreenchange', sync);
    }, []);
    useEffect(() => () => { if (isFullscreen()) document.exitFullscreen().catch(() => {}); }, []);

    if (full || !document.fullscreenEnabled) return null;
    const enter = () => document.documentElement.requestFullscreen().catch(() => toast.error('Your browser blocked full screen. Please allow it and try again.'));
    return (
        <div className="fixed inset-0 z-[2147482000] flex items-center justify-center bg-background/80 p-6 backdrop-blur-2xl" data-testid="fullscreen-gate">
            <div className="w-full max-w-md space-y-5 rounded-3xl border bg-card/95 p-8 text-center shadow-2xl">
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary"><Maximize className="h-7 w-7" /></div>
                <h2 className="font-heading text-2xl font-bold">Full screen required</h2>
                <p className="text-sm text-muted-foreground">
                    Your {attemptLabel || 'attempt'} runs in full screen. If you leave full screen, the page stays hidden until you return to it.
                </p>
                <Button onClick={enter} size="lg" className="w-full" data-testid="fullscreen-gate-enter-btn">
                    <Maximize className="mr-2 h-4 w-4" /> Enter full screen
                </Button>
            </div>
        </div>
    );
};
